import React from "react";
import svg92 from "../../../assets/svg/svg92.svg";
import svg93 from "../../../assets/svg/svg93.svg";
import svg94 from "../../../assets/svg/svg94.svg";
import svg95 from "../../../assets/svg/svg95.svg";
import svg96 from "../../../assets/svg/svg96.svg";

const items = [
  {
    title: "Integrity",
    svg: svg92,
    desc: "Every transaction should be traceable, fair, and secure.",
  },
  {
    title: "Innovation",
    svg: svg93,
    desc: "Technology that adapts to African realities and future needs.",
  },
  {
    title: "Transparency",
    svg: svg94,
    desc: "Every shilling is visible, every payment has proof.",
  },
  {
    title: "Partnership",
    svg: svg95,
    desc: "We grow with our clients through collaboration.",
  },
  {
    title: "Impact",
    svg: svg96,
    desc: "Tools that empower jobs, growth, and inclusion.",
  },
];
function CoreValues() {
  return (
    <div className="bg-busines-type impala-corners h-auto lg:py-[4.94rem] py-3 lg:px-[5.69rem] px-3">
      <div className=" flex flex-col items-center justify-center">
        <span className=" text-ink text-[3rem] font-[500] leading-[3.375rem]">
          Our Core Values
        </span>
        <span className="mt-[1rem] text-body text-[1.125rem] font-[400] leading-[1.625rem]">
          The principles that guide everything we do
        </span>
      </div>

       <div className="mt-[4rem] grid lg:grid-cols-3 grid-cols-1 gap-[1.98rem]">
        {items &&
          items?.map((item) => ( 
                    <div className="lg:max-h-[17.1875rem] h-auto ">
              <img className="w-[3rem] h-[3rem]" src={item?.svg} />
              <div className="mt-[1.25rem] text-ink text-[1.25rem] font-[500] leading-[1.75rem]">
                {item?.title}
              </div>
              <div className="mt-[.75rem] text-body text-[1.125rem] font-[400] leading-[1.625rem] lg:max-w-[22.6875rem] w-full">
                {item?.desc}
              </div> 
              </div>
          ))}
      </div> 
         </div> 
  );
}

export default CoreValues;
